/* @flow strict */

import * as React from 'react';

export type PropsType = {
  onClick: () => void,
  children?: React.Node
};

const Pending = ({
  onClick: handleClick,
  children
}: PropsType): React.Element<'div'> => (
  <div className="Loader__wrapper">
    <span title={children}>
      <button
        className="Loader"
        onClick={handleClick}
        aria-label="delete-user"
      >
        <i className="Loader__icon Loader__icon--refresh">refresh</i>
      </button>
    </span>
  </div>
);

export default Pending;
